import React from 'react'
import Img, { FluidObject } from 'gatsby-image'

type Props = {
  imageFluid: FluidObject
  className?: string
  alt?: string
  objectFit?: boolean
}

export const Image: React.VFC<Props> = ({
  imageFluid,
  className,
  alt,
  objectFit = false
}) => (
  <Img
    fluid={objectFit ? { ...imageFluid, aspectRatio: 1.7 } : imageFluid}
    className={className}
    alt={alt}
    imgStyle={objectFit ? { objectFit: 'contain' } : undefined}
  />
)
